import {
	LinearProgress,
	makeStyles
} from '@material-ui/core';
import React, { useEffect } from 'react';
import {
	BrowserView,
	isDesktop, MobileView
} from "react-device-detect";
import { useActions, useValues } from 'kea';

import { preferenceslogic } from 'src/store/global';
import profilelogic from 'src/store/profile';
import vehiclelogic from 'src/store/vehicle';

import Page from 'src/components/Page';
import checkRole from '../../utils/checkRole';
import GeofenceTablePanel from './GeofencePanel';
import GMaps from './GMaps';
import MobileTrackerPanel from './MobileTrackerPanel';
import ReplayPanel from './ReplayPanel';
import VehiclePanel from "./VehiclePanel";
import AssetPanel from "./AssetPanel";
import VehicleInfoWindow from './VehicleInfoWindow';
import AssetInfoWindow from './AssetInfoWindow';

//TODO clean styles
const useStyles = makeStyles(() => ({
	root: {
		height: '100%',
		width: '100%',
	},
	floatpanel: {
		// top: 48,
		// left: 73,
		zIndex: "1000",
		// position: "absolute",
		// height:467,
		// height:'100%',
		// width:'100%',
	},
	drawerOpen: {
		position: "fixed",
		// top: 45,
		// left:73,
		// overflow: 'auto'48px
		height: `calc(100% - 48px)`,
		width: isDesktop ? `calc(100% - 220px)` : '100%',
	},
	drawerClose: {
		position: "fixed",
		// top: 45,
		// left:73,
		// overflow: 'auto'
		height: `calc(100% - 48px)`,
		width: isDesktop ? `calc(100% - 72px)` : '100%',
	},
	map: {
		position: "fixed",
		// top: 45,
		// left:73,
		// overflow: 'auto'
		height: "100%",
		width: "100%",
	},

	iframe: {
		width: "100%",
		height: "100%",
	}
}));




// const socket = io("http://192.168.29:8000", {
// path: '/socket.io',
// transports: ['websocket'],
// secure: true,
// });

// socket.on('test', (data) => {
// 	console.log('socket data: ', data)
// })

const Dashboard = () => {

	const classes = useStyles();
	const { profile } = useValues(profilelogic);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: vehicleFetchAll } = useActions(vehiclelogic);

	const { vehicle, geofence, replay, drawer, asset } = useValues(preferenceslogic);

	useEffect(() => {
		if (checkRole(profile, ['VehicleView', 'VehicleEdit'])) {
			// tracker_initial_fetch();
			vehicles ?? vehicleFetchAll();
		}
	}, []) // eslint-disable-line


	return (
		<Page
			className={classes.root}
			title="Dashboard"
		>
			<div id={'panelHolder'} className={drawer.expand ? classes.drawerOpen : classes.drawerClose}>
				{/* <LeafletMap /> */}
				<GMaps />
			</div>
			{
				global.gmap === null ?
					<LinearProgress />
					:
					<>
						<BrowserView>
							<div className={classes.floatpanel}>
								{asset.show && checkRole(profile, ['AssetView', 'AssetEdit']) && <AssetPanel />}
								{vehicle.show && checkRole(profile, ['VehicleView', 'VehicleEdit']) && <VehiclePanel />}
								{geofence.show && checkRole(profile, ['GeofenceView', 'GeofenceEdit']) && <GeofenceTablePanel />}
								<VehicleInfoWindow />
								<AssetInfoWindow />
								{replay.show && <ReplayPanel />}
							</div>
						</BrowserView>
						<MobileView>
							<MobileTrackerPanel />
						</MobileView>
					</>
			}
		</Page>
	);
};

export default Dashboard;
